module.exports = __webpack_public_path__ + "static/Phone-13cf3648a05212753fbee61d460cbd38.png";